"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestedAmounts = exports.chipPrioritySort = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var components_1 = require("../../../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../../../analytics-subjects");
var copy_1 = require("../../../../../copy");
var chipIds = [
    'lastBill',
    'fullBalance',
    'predictedDebt',
    'fixed50',
    'fixed100',
];
function chipPrioritySort(a, b) {
    // if chip id isn't in id list it will appear first
    return chipIds.indexOf(a.id) < chipIds.indexOf(b.id) ? -1 : 1;
}
exports.chipPrioritySort = chipPrioritySort;
var SuggestedAmounts = function (_a) {
    var _b;
    var currentBalance = _a.currentBalance, lastBillAmount = _a.lastBillAmount, predictedFinalBalance = _a.predictedFinalBalance, calculationEndDate = _a.calculationEndDate, lastBillableDate = _a.lastBillableDate, isDebtRisk = _a.isDebtRisk, onClick = _a.onClick;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _c.copy, Copy = _c.Copy;
    var isInCredit = Number(currentBalance) >= 0;
    var features = (0, core_1.useFeatureContext)().features;
    var chips = [];
    chips.push({ id: 'fixed50', label: (0, core_1.smartMajor2DP)((0, core_1.majorToMinor)('50')) }, { id: 'fixed100', label: (0, core_1.smartMajor2DP)((0, core_1.majorToMinor)('100')) });
    if (lastBillAmount && Number(lastBillAmount.grossCharge.pounds) > 0) {
        chips.push({
            id: 'lastBill',
            label: (react_1.default.createElement(Copy, { copyKey: "cardPaymentSuggestedLastBill", values: {
                    amount: (0, core_1.smartMajor2DP)((0, core_1.majorToMinor)(lastBillAmount.grossCharge.pounds)),
                } })),
            description: lastBillableDate ? (react_1.default.createElement(Copy, { copyKey: "cardPaymentLastBillTooltip", values: {
                    date: (0, date_fns_1.format)(lastBillableDate, 'dd MMM'),
                } })) : (react_1.default.createElement(Copy, { copyKey: "cardPaymentLastBillNATooltip" })),
        });
    }
    if ((features === null || features === void 0 ? void 0 : features.showPredictedDebtChip) &&
        isDebtRisk &&
        predictedFinalBalance &&
        Number(predictedFinalBalance) < 0) {
        chips.push({
            id: 'predictedDebt',
            label: (react_1.default.createElement(Copy, { copyKey: "cardPaymentPredictedFinalBalance", values: {
                    amount: (0, core_1.smartMajor2DP)((0, core_1.majorToMinor)(Math.abs(Number(predictedFinalBalance)))),
                } })),
            description: calculationEndDate ? (react_1.default.createElement(Copy, { copyKey: "cardPaymentPredictedFinalBalanceTooltip", values: {
                    date: (0, date_fns_1.format)(calculationEndDate, 'dd MMM yyyy'),
                } })) : (react_1.default.createElement(Copy, { copyKey: "cardPaymentPredictedFinalBalanceNATooltip" })),
        });
    }
    if (currentBalance && !isInCredit) {
        chips.push({
            id: 'fullBalance',
            label: (react_1.default.createElement(Copy, { copyKey: "cardPaymentSuggestedFullAmount", values: {
                    amount: (0, core_1.smartMajor2DP)((0, core_1.majorToMinor)(Math.abs(Number(currentBalance)))),
                } })),
            description: react_1.default.createElement(Copy, { copyKey: "cardPaymentFullBalanceTooltip" }),
        });
    }
    chips.sort(chipPrioritySort);
    if (chips.length > 4) {
        // only ever show 4 chips
        // note: mutates in-place
        chips.splice(4);
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.SUGGESTED_AMOUNTS, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(components_1.ChipField, { "data-testid": "suggested-amounts-chips", label: copy('cardPaymentSuggestedAmountLabel'), id: "suggestedAmounts", onClick: function (id) { return onClick(id); }, options: chips })));
};
exports.SuggestedAmounts = SuggestedAmounts;
